import { Message, MessageBox } from 'element-ui';

/**
 * 显示提示
 * @param msg 提示信息 默认“保存成功”
 * @param level 提示级别（success/warning/info/error） 默认info
 * @param duration 持续时长（毫秒）默认2000，小于0不隐藏
 */
export function showTips(msg, level, duration) {
    msg = msg || '保存成功';
    level = level || 'info';
    duration =duration || 2000
    Message({
        message: msg,
        type: level,
        duration: duration
    });
}
/**
 * 确定弹框默认参数
 */
const confirmDefault = {
    msg: '',
    level: 'info',
    title: '提示',
    confirmCall: null,
    cancelCall: null,
    confirmBtnText: '确定',
    cancelBtnText: '取消'
};

/**
 * 显示确认弹框
 * options:{
 *  msg :"",
 *  level:"info",
 *  title:"提示",
 *  cancelCall:null,
 *  confirmCall:null,
 *  confirmBtnText:"确定",
 *  cancelBtnText :"取消"
 * }
 *
 */
async function confirm(options) {
    let param = {...options,...confirmDefault}
    try {
        let result = await MessageBox.confirm(param.msg, param.title, {
            confirmButtonText: param.confirmBtnText,
            cancelButtonText: param.cancelBtnText,
            type: param.level
        });
        if (result === 'confirm' && param.confirmCall) {
            param.confirmCall();
        }
        // 如果点击确认，返回true
        return true;
    } catch (error) {
        if (param.cancelCall) {
            param.cancelCall();
        }
        // 如果点击取消，返回false
        return false;
    }
}

/**
 * info级别confirm弹框
 * @param msg
 * @param confirmCall
 * @param cancelCall
 */
export async function confirmInfo(msg, confirmCall, cancelCall) {
    let result = await confirm({
        msg: msg,
        confirmCall: confirmCall,
        cancelCall: cancelCall
    });
    return result;
}

/**
 * warning级别confirm弹框
 * @param msg
 * @param confirmCall
 * @param cancelCall
 */
export async function confirmWarning(msg, confirmCall, cancelCall) {
    let result = await confirm({
        msg: msg,
        level: 'warning',
        confirmCall: confirmCall,
        cancelCall: cancelCall
    });
    return result;
}

/**
 * error级别confirm弹框
 * @param msg
 * @param confirmCall
 * @param cancelCall
 */
export async function confirmError(msg, confirmCall, cancelCall) {
    let result = await confirm({
        msg: msg,
        level: 'error',
        confirmCall: confirmCall,
        cancelCall: cancelCall
    });
    return result;
}
